window.getParameters = function(queryString?: string): Record<string, string>
{
	if (queryString === undefined)
	{
		queryString = window.location.search;
	}

	let result = null, tmp = [];
	let items = queryString.substr(1).split('&');
	let mapping: Record<string, string> = {};
	for (let index = 0; index < items.length; index++)
	{
		tmp = items[index].split('=');
		mapping[tmp[0]] = decodeURIComponent(tmp[1]);
	}

	return mapping;
};

window.getParameter = function (name: string, queryString?: string): string
{
	if (queryString === undefined)
	{
		queryString = window.location.search;
	}

	let result = null, tmp = [];
	let items = queryString.substr(1).split('&');
	for (let index = 0; index < items.length; index++)
	{
		tmp = items[index].split('=');

		if (tmp[0] === name)
		{
			return decodeURIComponent(tmp[1]);
		}
	}

	return '';
};

window.setParameter = function (name: string, value: string | null)
{
	let v = value == null ? '' : name + '=' + value;
	let href = window.location.href;
	let regex = new RegExp('[&\\?]' + name + '=');

	if (regex.test(href))
	{
		regex = new RegExp('([&\\?])' + name + '=[^&]*');
		href = href.replace(regex, '$1' + v);
	}
	else
	{
		if (href.indexOf('?') > -1)
		{
			href = href + '&' + name + '=' + value;
		}
		else
		{
			href = href + '?' + name + '=' + value;
		}
	}

	if (window.location.hash)
	{
		href += window.location.hash;
	}

	window.history.replaceState(window.history.state, '', href);
};

window.parseHTML = function(html: string, processJavaScriptTemplates?: boolean): Document
{
	if (processJavaScriptTemplates === undefined)
	{
		processJavaScriptTemplates = true;
	}

	let tmp = document.implementation.createHTMLDocument();

	if (html.indexOf('<html') > -1)
	{
		// This is a full HTML document: replace the contents of the root document element.
		tmp.documentElement.innerHTML = html;
	}
	else
	{
		// This is a partial HTML document: replace the contents of the <body> element.
		tmp.body.innerHTML = html;
	}

	if (processJavaScriptTemplates)
	{
		// Convert inline HTML templates (<script type="text/html">...</script>) back to HTML before returning the Document object.
		let scriptElements = tmp.querySelectorAll('script[type="text/html"]') as NodeListOf<HTMLScriptElement>;

		for (let i = scriptElements.length - 1; i >= 0; i--)
		{
			scriptElements[i].replaceWith(window.parseHTML(scriptElements[i].text).body.childNodes[0]);
		}
	}

	return tmp;
};

if (!window.setImmediate)
{
	window.setImmediate = function (f: Function)
	{
		setTimeout(f, 0);
	};
}

export {};